import { queryOptions } from "@tanstack/react-query";
import { fetchPublicApiTokens } from "@/features/public-api/api/tokens.api";

export const publicApiTokensKeys = {
  all: ["public-api-tokens"] as const,
  list: () => ["public-api-tokens", "list"] as const,
};

export function publicApiTokensListQueryOptions() {
  return queryOptions({
    queryKey: publicApiTokensKeys.list(),
    queryFn: () => fetchPublicApiTokens(),
  });
}
